import { render, staticRenderFns } from "./whatsAppMessagingInput.vue?vue&type=template&id=10fcfc18"
import script from "./whatsAppMessagingInput.vue?vue&type=script&lang=ts"
export * from "./whatsAppMessagingInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports